import { useMemo } from 'react';
import { Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faLink, faVideo, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-regular-svg-icons';

import './request-file-image.css';

export function RequestFileImage(props) {
    const { requestFile } = props;
    const { imageUrl, imageIcon } = useMemo(() => {
        let imageIcon;
        if (requestFile.fileVariant === 'VIDEO_LINK') {
            imageIcon = faLink;
        } else {
            if (requestFile.mimeType) {
                if (requestFile.mimeType.startsWith('image')) imageIcon = faImage;
                else if (requestFile.mimeType.startsWith('video')) imageIcon = faVideo;
                else if (requestFile.mimeType.startsWith('video')) imageIcon = faVolumeUp;
                else imageIcon = faFile;
            } else imageIcon = faFile;
        }
        const imageUrl =
            requestFile.hasSmallThumbnail && requestFile.code ? '/file/thumbnail/small/' + requestFile.code : '';
        return { imageUrl, imageIcon };
    }, [requestFile]);
    return (
        <div className="request-image-container">
            {imageUrl ? (
                <Image className="border" src={imageUrl} rounded />
            ) : (
                <FontAwesomeIcon icon={imageIcon} size="2x" />
            )}
        </div>
    );
}
